import { Inbox, ShieldCheck, UserCog } from 'lucide-react'

import type { NavItem } from '@/shared/layout/navigation'

export const accessNavigation: NavItem[] = [
  {
    to: '/access-requests',
    labelKey: 'nav.accessRequests',
    group: 'nav.groups.users',
    icon: Inbox,
    permission: 'users.view',
  },
  {
    to: '/admins',
    labelKey: 'nav.admins',
    group: 'nav.groups.users',
    icon: UserCog,
    permission: 'admins.view',
  },
  {
    to: '/roles',
    labelKey: 'nav.roles',
    group: 'nav.groups.users',
    icon: ShieldCheck,
    permission: 'admins.view',
  },
]
